import React from 'react';
import GuestImageGeneration from '@/components/GuestImageGeneration';
import SEO, { softwareApplicationSchema } from '@/components/SEO';

const TryGenerator = () => {
  return (
    <>
      <SEO
        title="Free AI Image Generator | Try FLUX Model Online"
        description="Try our free AI image generator powered by FLUX.1-Schnell. Generate up to 5 images daily without signup. Experience professional AI image creation instantly."
        keywords="free ai image generator, try ai images, flux ai free, ai image maker, generate images online, free image generator"
        url="/try-generator"
        jsonLd={softwareApplicationSchema}
      />
      <GuestImageGeneration />
    </>
  );
};

export default TryGenerator;